import React from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import MachineLogoIcon from "../../shared/assets/icons/MachineLogoIcon";
import AccountMobileMenu from "./AccountMobileMenu";
import Menu from "../../shared/components/Menu";
import AccountHeader from "./AccountHeader";

const AccountLayout = () => {
  return (
    <>
      <Box sx={{ display: { xs: "none", md: "flex" }, width: "100%" }}>
        <Menu />
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", flex: 1 }}>
          <AccountHeader />
          <Outlet />
        </Box>
      </Box>

      <Box className="w-full max-w-[1023px] mx-auto flex flex-col h-fit" sx={{ display: { xs: "flex", md: "none" } }}>
        <Box className="flex justify-between items-center px-4 py-6 relative" sx={{ minHeight: "88px" }}>
          <MachineLogoIcon />

          <Box>
            <AccountMobileMenu />
          </Box>
        </Box>
        <Outlet />
      </Box>
    </>
  );
};

export default AccountLayout;


